/* eslint-disable */
/**
 * Minified by jsDelivr using UglifyJS v3.4.4.
 * Original file: /npm/dsbridge@3.1.4/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
var bridge = {
    default: this,
    call: function (i, t, s) {
        var d = '';
        'function' == typeof t && ((s = t), (t = {}));
        var e = {
            data: void 0 === t ? null : t
        };
        if ('function' == typeof s) {
            var a = 'dscb' + window.dscb++;
            (window[a] = s), (e._dscbstub = a);
        }
        return (e = JSON.stringify(e)), window._dsbridge ? (d = _dsbridge.call(i, e)) : (window._dswk || -1 != navigator.userAgent.indexOf('_dsbridge')) && (d = prompt('_dsbridge=' + i, e)), JSON.parse(d || '{}').data;
    },
    register: function (i, t, s) {
        var d = s ? window._dsaf : window._dsf;
        window._dsInit ||
            ((window._dsInit = !0),
                setTimeout(function () {
                    bridge.call('_dsb.dsinit');
                }, 0)),
            'object' == typeof t ? (d._obs[i] = t) : (d[i] = t);
    },
    registerAsyn: function (i, t) {
        this.register(i, t, !0);
    },
    hasNativeMethod: function (i, t) {
        return this.call('_dsb.hasNativeMethod', {
            name: i,
            type: t || 'all'
        });
    },
    disableJavascriptDialogBlock: function (i) {
        this.call('_dsb.disableJavascriptDialogBlock', {
            disable: !1 !== i
        });
    }
};
!(function () {
    if (!window._dsf) {
        var i = {
            _dsf: {
                _obs: {}
            },
            _dsaf: {
                _obs: {}
            },
            dscb: 0,
            dsBridge: bridge,
            close: function () {
                bridge.call('_dsb.closePage');
            },
            _handleMessageFromNative: function (i) {
                var s = JSON.parse(i.data),
                    d = {
                        id: i.callbackId,
                        complete: !0
                    },
                    t = this._dsf[i.method],
                    e = this._dsaf[i.method],
                    a = function (i, t) {
                        (d.data = i.apply(t, s)), bridge.call('_dsb.returnValue', d);
                    },
                    n = function (i, t) {
                        s.push(function (i, t) {
                                (d.data = i), (d.complete = !1 !== t), bridge.call('_dsb.returnValue', d);
                            }),
                            i.apply(t, s);
                    };
                if (t) a(t, this._dsf);
                else if (e) n(e, this._dsaf);
                else {
                    var o = i.method.split('.');
                    if (o.length < 2) return;
                    var r = o.pop(),
                        f = o.join('.'),
                        l = this._dsf._obs,
                        c = l[f] || {},
                        _ = c[r];
                    if (_ && 'function' == typeof _) return void a(_, c);
                    if ((_ = (c = (l = this._dsaf._obs)[f] || {})[r]) && 'function' == typeof _) return void n(_, c);
                }
            }
        };
        for (var t in i) window[t] = i[t];
        bridge.register('_hasJavascriptMethod', function (i, t) {
            var s = i.split('.');
            if (s.length < 2) return !(!_dsf[s] && !_dsaf[s]);
            i = s.pop();
            var d = s.join('.'),
                e = _dsf._obs[d] || _dsaf._obs[d];
            return e && !!e[i];
        });
    }
})();
export default bridge

//# sourceMappingURL=/sm/eca1ea87ee8f9d91c3726b0cf4f90a7ad72ab849afa7a8e713e2ab502c27deda.map